import React from "react";
import { speakText } from "../utils/speech";
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function WordListView({ words, onBack }) {
    const isChinese = words.length > 0 && 'chinese' in words[0];

    const speak = (text, lang) => speakText(text, lang === 'zh-CN' ? 'zh' : 'en');

    return (
        <div className="wordlist-view">
            <h2 className="wordlist-title">
                <AutoStoriesIcon className="icon-md" />
                Complete Word List
            </h2>

            <div className="wordlist-container">
                {words.map((wordObj, index) => (
                    <div key={index} className={`wordlist-item ${index % 2 === 0 ? 'even' : 'odd'}`}>
                        <div className="wordlist-item-header">
                            <span className="wordlist-number">#{index + 1}</span>
                            <button
                                className="wordlist-sound-btn"
                                onClick={() => speak(
                                    isChinese ? wordObj.chinese : wordObj.word,
                                    isChinese ? "zh-CN" : "en-SG"
                                )}
                            >
                                <VolumeUpIcon className="icon-sm" />
                            </button>
                        </div>
                        <div className="wordlist-content">
                            {isChinese ? (
                                <>
                                    <div className="wordlist-word wordlist-chinese-char">{wordObj.chinese}</div>
                                    {wordObj.pinyin && (
                                        <div className="wordlist-meaning">
                                            <span className="wordlist-meaning-label en">PY:</span> {wordObj.pinyin}
                                        </div>
                                    )}
                                    {wordObj.english && (
                                        <div className="wordlist-meaning">
                                            <span className="wordlist-meaning-label zh">EN:</span> {wordObj.english}
                                        </div>
                                    )}
                                </>
                            ) : (
                                <>
                                    <div className="wordlist-word">{wordObj.word}</div>
                                    {wordObj.meaningEn && (
                                        <div className="wordlist-meaning">
                                            <span className="wordlist-meaning-label en">EN:</span> {wordObj.meaningEn}
                                        </div>
                                    )}
                                    {wordObj.meaningZh && (
                                        <div className="wordlist-meaning">
                                            <span className="wordlist-meaning-label zh">ZH:</span> {wordObj.meaningZh}
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            <button className="btn btn-primary wordlist-back-btn" onClick={onBack}>
                <ArrowBackIcon className="icon-sm" />
                Back to Menu
            </button>
        </div>
    );
}
